// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"54e19907","555":"a07c5190","605":"170424d3"}[chunkId] + ".chunk.css";
};